import { render } from "./skeleton.vue?vue&type=template&id=5dc5392a&ts=true"
import script from "./skeleton.vue?vue&type=script&lang=ts"
export * from "./skeleton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__